<template>
  <div class="pj-contaniner pj-line-border" :class="{vertical: isVertical, Lvertical:LisVertical}" :style="{'border-left-color':color, 'border-right-color':color, 'color':color}">
    <div class="pj-leftArrow arrow"></div>
    <div class="pj-middle" :style="{'width': arrowWidth / 100 * 2.67 + 'rem','background-color':color}"></div>
    <div class="pj-rightArrow arrow"></div>
  </div>
</template>

<script>
export default {
  name: 'simpleProjectArrow',
  data () {
    return {
      arrowOffset: 5
    }
  },

  props: ['color', 'PjItemWidth', 'isVertical', 'LisVertical'],

  components: {},

  computed: {
    arrowWidth () {
      return this.isVertical ? this.PjItemWidth - this.arrowOffset : this.PjItemWidth
    }
  },

  mounted () {},

  methods: {}
}

</script>
<style scoped>
.pj-contaniner {
 position: relative;
}

.pj-line-border {
 border-left: 2px solid;
 border-right: 2px solid;
}

.pj-height {
  height: 323px;
  width: 140px;
  position: absolute;
  left: 438px;
  top: 230px;
}

.arrow {
  position: relative;
}

.pj-leftArrow {
  left: -7px;
  bottom: -7px;
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-color:transparent;
  border-right-color: inherit;
}
.pj-rightArrow {
  left: calc(100% - 5px);
  bottom: 7px;
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-color:transparent;
  border-left-color: inherit;
}
.pj-middle {
  height: 2px;
  position: relative;
}

.vertical {
 transform: rotate(-90deg);
 transform-origin: right bottom;
}

.Lvertical {
 transform: rotate(90deg);
 transform-origin: left top;
}
</style>
